import { createZodDto } from "nestjs-zod/dto";

import { storedEmailSchema, userSchema } from "./user";

export const updateUserSchema = userSchema
  .partial()
  .pick({
    name: true,
    locale: true,
    username: true,
    email: true,
    picture: true,
  })
  .extend({ email: storedEmailSchema.optional() });

export class UpdateUserDto extends createZodDto(updateUserSchema) {}
